/** HTTP contracts shared by the API and the web SPA. */
import { z } from 'zod';
export const dependencyStatusSchema = z.object({
    name: z.enum(['postgres', 'redis', 'storage']),
    ok: z.boolean(),
    latencyMs: z.number().nonnegative(),
    detail: z.string().optional(),
});
export const healthResponseSchema = z.object({
    status: z.enum(['ok', 'degraded']),
    service: z.string(),
    version: z.string(),
    uptimeSeconds: z.number().nonnegative(),
    dependencies: z.array(dependencyStatusSchema),
});
/** Shape of every error the API returns. One shape, always. */
export const apiErrorSchema = z.object({
    statusCode: z.number(),
    code: z.string(),
    message: z.string(),
    requestId: z.string().optional(),
});
//# sourceMappingURL=api.js.map